import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";
import {
  Button,
  Box,
  Typography,
  Grid,
  MenuItem,
  useMediaQuery,
  InputLabel,
  Select,
  TextField,
  IconButton,
  InputAdornment,
  makeStyles,
  FormControl,
  FormHelperText,
} from "@material-ui/core";
import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";

import { useAlert } from "../components/Alert";
import LoadingFloating from "../components/LoadingFloating";

const iconArr = [
  {
    iconImg: require("../images/line.png").default,
    href: "https://line.me/zh-hant/",
  },
  {
    iconImg: require("../images/facebook.png").default,
    href: "https://www.facebook.com",
  },
  {
    iconImg: require("../images/wechat.png").default,
    href: "https://www.wechat.com/zh_HK/",
  },
];

const SEND_VERIFICATIONCODE = gql`
  mutation sendVerificationCode($mobile: String!) {
    sendVerificationCode(mobile: $mobile)
  }
`;
const REGISTER = gql`
  mutation register($userInput: UserInput!, $console: Boolean) {
    register(userInput: $userInput, console: $console) {
      id
    }
  }
`;
export default function RegisterPage() {
  return (
    <div>
      <RegisterPageContent />
    </div>
  );
}

function RegisterPageContent() {
  const useStyles = makeStyles((theme) => ({
    contentBox: {
      height: "100%",
      position: "relative",
    },
    contentImg: {
      position: "absolute",
      height: "100%",
      width: "100%",
      zIndex: "-1",
    },
  }));
  const classes = useStyles();
  return (
    <Box className={classes.contentBox}>
      <Grid height="100%">
        <img
          src={"/assets/images/Login/loginImg.png"}
          className={classes.contentImg}
        />
        <Grid>
          <Grid container justify="center">
            <Grid item xs={11} sm={9} md={7} lg={5}>
              <RegisterPageForm />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

function RegisterPageForm() {
  const isPhone = useMediaQuery("(max-width:376px)");
  const isPad = useMediaQuery("(max-width:576px)");
  const isTable = useMediaQuery("(max-width:960px)");
  const Alert = useAlert();
  const history = useHistory();
  const [verifying, setVerifying] = useState(false);
  const verifyPattern = /^[0-9]{6}$/;

  const useStyles = makeStyles((theme) => ({
    SocialIconImg: {
      width: "50x",
      height: "50px",
      objectFit: "contain",
      verticalAlign: "middle",
      transition: "all 0.1s",
      "&:hover": {
        transform: "scale(1.1)",
      },
    },
    buttonBox: {
      display: "flex",
      marginTop: isPhone
        ? "50px"
        : isPad
        ? "70px"
        : isTable
        ? "100px"
        : "150px",
      marginBottom: " 20px",
      marginRight: "auto",
      marginLeft: "auto",
    },
    button: {
      backgroundColor: theme.palette.secondary.light,
      color: "white",
      width: isPhone ? "120px" : isPad ? "150px" : isTable ? "200px" : "250px",
      height: isPhone ? "40px" : isPad ? "45px" : isTable ? "50px" : "55px",
      fontSize: isPhone ? "1rem" : isPad ? "1.25rem" : "1.5rem",
      borderRadius: isPhone
        ? "20px"
        : isPad
        ? "23px"
        : isTable
        ? "25px"
        : "100px",
      "&:hover": {
        backgroundColor: theme.palette.secondary.light,
      },
    },
    input: {
      backgroundColor: "white",
      borderRadius: "4px",
      marginBottom: "20px",
    },
    title: {
      color: "white",
      fontWeight: "bold",
      textAlign: "center",
      margin: "80px 0px",
    },
  }));
  const classes = useStyles();
  // const history = useHistory();
  const [showPassword, setShowPassword] = useState(false);
  const { handleSubmit, control, getValues } = useForm({
    defaultValues: {
      fullName: "",
      gender: "",
      mobile: "",
      password: "",
      email: "",
      verificationCode: "",
    },
  });
  const [register, { loading: registerLoading }] = useMutation(REGISTER, {
    onCompleted({ register }) {
      if (register) {
        return Alert.notice("註冊成功！", () => history.replace("/log-in"));
      } else {
        return Alert.notice("註冊失敗，請重新嘗試！");
      }
    },
    onError(error) {
      return Alert.notice(error.message.replace("GraphQL error: ", ""));
    },
  });
  const [sendVerificationCode, { loading }] = useMutation(
    SEND_VERIFICATIONCODE,
    {
      onCompleted({ sendVerificationCode }) {
        if (sendVerificationCode) {
          return Alert.notice("驗證碼發送成功！", setVerifying(true));
        } else {
          return Alert.notice("驗證碼發送失敗，請重新嘗試！");
        }
      },
      onError(error) {
        return Alert.notice(error.message.replace("GraphQL error: ", ""));
      },
    }
  );
  function _sendVerification() {
    sendVerificationCode({
      variables: { mobile: getValues().mobile },
    });
  }
  function _register(data) {
    const userInput = {
      ...data,
      identity: "MEMBER",
      enabled: true,
    };
    register({ variables: { userInput, console: false } });
  }

  return (
    <Box>
      <LoadingFloating loading={loading || registerLoading} />
      <Box padding={1}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography variant="h4" className={classes.title}>
              加入會員
            </Typography>
          </Grid>
          <Grid container item justify="space-between" spacing={2}>
            <Grid item xs={12} md={6}>
              <InputLabel style={{ color: "white", fontSize: "1.5rem" }} shrink>
                姓名
              </InputLabel>
              <Controller
                name="fullName"
                control={control}
                rules={{
                  required: "請填寫姓名",
                }}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    className={classes.input}
                    {...field}
                    error={error}
                    helperText={error && error.message}
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InputLabel style={{ color: "white", fontSize: "1.5rem" }} shrink>
                性別
              </InputLabel>
              <Controller
                name="gender"
                control={control}
                rules={{
                  required: "請輸入性別",
                }}
                render={({ field, fieldState: { error } }) => (
                  <FormControl
                    size="small"
                    variant="outlined"
                    fullWidth
                    error={error}
                    className={classes.input}
                  >
                    <Select {...field}>
                      <MenuItem value={"MALE"}>男</MenuItem>
                      <MenuItem value={"FEMALE"}>女</MenuItem>
                    </Select>
                    <FormHelperText>{error && error.message}</FormHelperText>
                  </FormControl>
                )}
              />
            </Grid>
          </Grid>
          <InputLabel style={{ color: "white", fontSize: "1.5rem" }} shrink>
            電話
          </InputLabel>
          <Grid container item>
            <Controller
              name="mobile"
              control={control}
              rules={{
                required: "請填入電話",
                pattern: {
                  value: /^[0-9]{10}$/,
                  message: "電話號碼格式錯誤",
                },
              }}
              render={({ field, fieldState: { error } }) => (
                <>
                  <TextField
                    {...field}
                    placeholder="手機號碼即為登入帳號"
                    className={classes.input}
                    error={error}
                    helperText={error && error.message}
                    fullWidth
                    style={{ flex: 1 }}
                  />
                  &ensp;
                  <Button
                    variant="contained"
                    onClick={_sendVerification}
                    disabled={error}
                    style={{ height: "37.63px", backgroundColor: "#f44336" }}
                  >
                    <Typography
                      variant="caption"
                      style={{ padding: "0px 10px", color: "#fff" }}
                    >
                      電話驗證
                    </Typography>
                  </Button>
                </>
              )}
            />
          </Grid>
          <Grid container item>
            <InputLabel style={{ color: "white", fontSize: "1.5rem" }} shrink>
              驗證碼
            </InputLabel>
            <Controller
              name="verificationCode"
              control={control}
              rules={{
                required: "驗證碼未輸入",
                pattern: {
                  value: verifyPattern,
                  message: "驗證碼格式不正確！",
                },
              }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  className={classes.input}
                  placeholder={verifying ? "驗證碼" : "請先按下電話驗證"}
                  {...field}
                  error={error}
                  helperText={error?.message}
                  disabled={!verifying}
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid container item justify="space-between" spacing={2}>
            <Grid container item xs={12} md={6}>
              <InputLabel style={{ color: "white", fontSize: "1.5rem" }} shrink>
                密碼
              </InputLabel>
              <Controller
                name="password"
                control={control}
                rules={{
                  required: "請填寫密碼",
                }}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    className={classes.input}
                    type={showPassword ? "text" : "password"}
                    {...field}
                    fullWidth
                    error={error}
                    helperText={error && error.message}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment>
                          <IconButton
                            size="small"
                            onClick={() => setShowPassword((e) => !e)}
                          >
                            {showPassword ? (
                              <VisibilityIcon />
                            ) : (
                              <VisibilityOffIcon />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            <Grid container item xs={12} md={6}>
              <InputLabel style={{ color: "white", fontSize: "1.5rem" }} shrink>
                信箱
              </InputLabel>
              <Controller
                name="email"
                control={control}
                rules={{
                  required: "請填寫信箱",
                }}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    className={classes.input}
                    {...field}
                    error={error}
                    helperText={error && error.message}
                    fullWidth
                  />
                )}
              />
            </Grid>
          </Grid>
          <Grid className={classes.buttonBox}>
            {iconArr.map((item) => {
              return (
                <Grid>
                  <Button href={item.href}>
                    <img src={item.iconImg} className={classes.SocialIconImg} />
                  </Button>
                </Grid>
              );
            })}
          </Grid>
          <Grid
            container
            item
            style={{ justifyContent: "center", marginBottom: "30px" }}
          >
            <Grid item>
              <Button
                className={classes.button}
                onClick={handleSubmit(_register)}
              >
                送出
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
